import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';

@Component({
  selector: 'app-assesment-marks-entry',
  templateUrl: './assesment-marks-entry.component.html',
  styleUrls: ['./assesment-marks-entry.component.scss']
})
export class AssesmentMarksEntryComponent implements OnInit {

  assesmentMarksForm: FormGroup;
  ListOfMarks: any;
  filteredListOfMarks: any;
  SessionNo: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder) { }


  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null)
    {
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null)
    {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.assesmentMarksForm = this.fb.group({
      list: new FormControl(),
      list2: new FormControl(),
      list3: new FormControl(),
      Valid: new FormControl(),
      Change: new FormControl(),
      Sub: new FormControl(),
      Paper: new FormControl(),
      Batch: new FormControl(),
      Subject: new FormControl(),
      Subject1 : new FormControl(),
      UID: new FormControl(),
      Marks: new FormControl(),
      Grade: new FormControl(),
      Delete: new FormControl(),
      Valid2: new FormControl(),
      Valid3: new FormControl(),
    });
  }
  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  fetchList(){
    let payload = {}
    payload ["SnNo"] = this.SessionNo;
    payload["InCode"] = 7;
    payload["OpId"] = sessionStorage.getItem('userId');
    this.umsService.fetchRegiList(payload).subscribe((res) => {
    if (res.status) {
      this.ListOfMarks = res.data;
      this.filteredListOfMarks = this.ListOfMarks.slice();
    }
    else {
    
    }
    
    });
    
      }
}
